import {
  AddToBasketSectionSkeleton,
  BreadcrumbsADPLoading,
  PriceAndBrandLoading,
  ProductDetailsAccordionsLoading,
  ProductImageGridLoading,
  ProductSelectionGridSkeleton,
  ProductUSPsLoading,
} from '@aboutyou/logic-components';
import {styled} from '@linaria/react';
import React from 'react';
import {
  ArticleDetailSplitViewGrid,
  BuyboxTopSpacer,
  ImageSectionWrapper,
  breadcrumbsStyles,
} from './ArticleDetailLayout';

export const ArticleDetailBuyboxSkeleton: React.FC = () => {
  return (
    <BuyboxTopSpacer>
      <StyledBreadcrumbsLoading />
      <PriceAndBrandLoading />
      <ProductSelectionGridSkeleton />
      <StyledAddToBasketSectionSkeleton />
      <ProductUSPsLoading />
      <ProductDetailsAccordionsLoading />
    </BuyboxTopSpacer>
  );
};

export const ArticleDetailSkeleton: React.FC = () => {
  return (
    <div data-ssr-skeleton="ADPPageSkeleton">
      <ArticleDetailSplitViewGrid
        split={'6:5'}
        contentStart={
          <ImageSectionWrapper>
            <ProductImageGridLoading />
          </ImageSectionWrapper>
        }
        contentEnd={
          <div>
            <ArticleDetailBuyboxSkeleton />
          </div>
        }
      />
    </div>
  );
};

const StyledBreadcrumbsLoading = styled(BreadcrumbsADPLoading)`
  ${breadcrumbsStyles}
`;

const StyledAddToBasketSectionSkeleton = styled(AddToBasketSectionSkeleton)`
  margin: 1.5rem 0 1.35rem 0;
`;
